import { type RouteRecordRaw } from "vue-router";

import {
  APP_PATIENTS_ROUTES as PATIENTS,
  APP_PATIENTS_VIEW_ROUTES as PATIENTS_VIEW,
  APP_PATIENTS_ASSIGNMENTS_ROUTES as PATIENTS_ASSIGNMENTS,
  APP_PATIENTS_VIEW_INFO_ROUTES as PATIENT_INFO_ROUTES,
  APP_PATIENTS_VIEW_CLINICALDOCUMENTATION_ROUTES as CLINICAL_DOCUMENTATION_ROUTES,
  APP_PATIENTS_VIEW_FORMS_ROUTES as FORMS_ROUTES,
} from "@/Generated/Routes/paths";

import { buildBeforeEnterChain, patientClinicalDocumentationSessionGuard } from "@/Router/guards";

export default [
  {
    ...PATIENTS.root,
    components: { main: () => import("@/Views/patients/index.vue") },
    meta: { sidebar: false },
  },
  {
    ...PATIENTS_ASSIGNMENTS.root,
    components: { main: () => import("@/Views/patients/List/PatientPool/index.vue") },
    meta: { sidebar: false },
  },
  {
    path: PATIENTS_VIEW.root.path,
    components: { main: () => import("@/Views/patients/Layouts/PatientsView.vue") },
    meta: { sidebar: false },
    children: [
      {
        ...PATIENTS_VIEW.root,
        component: () => import("@/Views/patients/Detail/PersonalData/index.vue"),
      },
      {
        path: PATIENT_INFO_ROUTES.root.path,
        component: () => import("@/Views/patients/Detail/PersonalData/index.vue"),
        children: [
          {
            path: "",
            redirect: PATIENT_INFO_ROUTES.view.root.name,
          },
          {
            ...PATIENT_INFO_ROUTES.view.root,
            component: () => import("@/Views/patients/Detail/PersonalData/View.vue"),
          },
          {
            ...PATIENT_INFO_ROUTES.edit.root,
            component: () => import("@/Views/patients/Detail/PersonalData/Edit.vue"),
          },
        ],
      },
      {
        ...PATIENTS_VIEW.subscription.root,
        component: () => import("@/Views/patients/Detail/Subscription/index.vue"),
      },
      {
        path: CLINICAL_DOCUMENTATION_ROUTES.root.path,
        component: () => import("@/Views/patients/Detail/ClinicalDocumentation/index.vue"),
        children: [
          {
            ...CLINICAL_DOCUMENTATION_ROUTES.root,
            component: () => import("@/Views/patients/Detail/ClinicalDocumentation/List/index.vue"),
          },
          {
            ...CLINICAL_DOCUMENTATION_ROUTES.clinicalNotes.root,
            component: () => import("@/Views/patients/Detail/ClinicalDocumentation/ClinicalNotes.vue"),
            props: { isEditMode: false },
          },
          {
            ...CLINICAL_DOCUMENTATION_ROUTES.view.root,
            component: () => import("@/Views/patients/Detail/ClinicalDocumentation/Detail.vue"),
            beforeEnter: buildBeforeEnterChain(patientClinicalDocumentationSessionGuard),
          },
          {
            ...CLINICAL_DOCUMENTATION_ROUTES.register.root,
            component: () => import("@/Views/patients/Detail/ClinicalDocumentation/Register.vue"),
          },
        ],
      },
      {
        ...PATIENTS_VIEW.appointments.root,
        component: () => import("@/Views/patients/Detail/Appointments/index.vue"),
      },
      {
        path: FORMS_ROUTES.root.path,
        component: () => import("@/Views/patients/Detail/Forms/Layout.vue"),
        meta: { sidebar: false },
        children: [
          {
            ...FORMS_ROUTES.root,
            component: () => import("@/Views/patients/Detail/Forms/List.vue"),
          },
          {
            ...FORMS_ROUTES.answers.root,
            component: () => import("@/Views/patients/Detail/Forms/Detail.vue"),
          },
        ],
      },
      {
        ...PATIENTS_VIEW.legals.root,
        component: () => import("@/Views/patients/Detail/Legals/index.vue"),
      },
    ],
  },
] as RouteRecordRaw[];
